__turbopack_context__.v({
  "activeFilterBtn": "FiltersAddOns-module-scss-module__v72xHq__activeFilterBtn",
  "activeFilterItem": "FiltersAddOns-module-scss-module__v72xHq__activeFilterItem",
  "activeFilterName": "FiltersAddOns-module-scss-module__v72xHq__activeFilterName",
  "activeFilterRemove": "FiltersAddOns-module-scss-module__v72xHq__activeFilterRemove",
  "activeFiltersContent": "FiltersAddOns-module-scss-module__v72xHq__activeFiltersContent",
  "activeFiltersList": "FiltersAddOns-module-scss-module__v72xHq__activeFiltersList",
  "activeFiltersSection": "FiltersAddOns-module-scss-module__v72xHq__activeFiltersSection",
  "clearAllFiltersItem": "FiltersAddOns-module-scss-module__v72xHq__clearAllFiltersItem",
  "filterGroup": "FiltersAddOns-module-scss-module__v72xHq__filterGroup",
  "filterHeader": "FiltersAddOns-module-scss-module__v72xHq__filterHeader",
  "filtersContainer": "FiltersAddOns-module-scss-module__v72xHq__filtersContainer",
  "filtersContainerInline": "FiltersAddOns-module-scss-module__v72xHq__filtersContainerInline",
  "filtersTitle": "FiltersAddOns-module-scss-module__v72xHq__filtersTitle",
  "showMoreBtn": "FiltersAddOns-module-scss-module__v72xHq__showMoreBtn",
  "subfilterLabel": "FiltersAddOns-module-scss-module__v72xHq__subfilterLabel",
  "subfilterLabelDisabled": "FiltersAddOns-module-scss-module__v72xHq__subfilterLabelDisabled",
  "subfilterLabelSelected": "FiltersAddOns-module-scss-module__v72xHq__subfilterLabelSelected",
  "subfilters": "FiltersAddOns-module-scss-module__v72xHq__subfilters",
});
